import { type PolledDepotReset } from '../hooks/usePollDepotReset';

export interface DepotSummaryCounts {
  depotCount: number;
  succeeded: number;
  withErrors: number;
}

type DepotSummaries = PolledDepotReset['depotSummaries'];

/**
 * Per-depot tally shared by the modal's summary step and the completion toast,
 * so the two cannot disagree.
 *
 * A depot where only some assets applied is not a failed depot, so
 * PARTIAL_SUCCESS is tallied alongside FAILURE under `withErrors` rather than
 * under `succeeded`.
 */
export function buildDepotSummaryCounts(
  depotSummaries: DepotSummaries,
): DepotSummaryCounts {
  return {
    depotCount: depotSummaries.length,
    succeeded: depotSummaries.filter((s) => s.appliedStatus === 'SUCCESS')
      .length,
    withErrors: depotSummaries.filter(
      (s) =>
        s.appliedStatus === 'PARTIAL_SUCCESS' || s.appliedStatus === 'FAILURE',
    ).length,
  };
}
